'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from 'react';
import PropTypes from 'prop-types';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import H3 from 'UIComponents/elements/headings/H3';
import HR from 'UIComponents/elements/HR';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UISearchInput from 'UIComponents/input/UISearchInput';
import ReviewFilters from 'marketplace-ui-reviews/records/ReviewFilters';
import LegacyReviewFilters from '../../records/ReviewFilters';
import { SEARCH_KEY } from '../../constants/reviews/ReviewsListQueries';
const textPath = 'ecosystemMarketplaceCore.reviews.list';

const ReviewsHeader = ({
  onUpdateFilters,
  renderedButtonRow = null,
  renderedInlineActions = null,
  reviewsCount,
  reviewFilters,
  showDivider = true
}) => {
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [renderedButtonRow, /*#__PURE__*/_jsxs(UIFlex, {
      justify: "between",
      align: "center",
      wrap: "wrap",
      children: [/*#__PURE__*/_jsx(UITooltip, {
        placement: "right",
        role: "tooltip",
        title: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: `${textPath}.tooltip`
        }),
        children: /*#__PURE__*/_jsx(H3, {
          "aria-level": 3,
          className: "m-bottom-0 is--heading-4",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `${textPath}.header`,
            options: {
              count: reviewsCount
            }
          })
        })
      }), /*#__PURE__*/_jsxs(UIFlex, {
        justify: "end",
        align: "center",
        children: [/*#__PURE__*/_jsx(UIFormControl, {
          "aria-label": I18n.text(`${textPath}.search`),
          children: /*#__PURE__*/_jsx(UISearchInput, {
            value: reviewFilters.get(SEARCH_KEY.toLowerCase()),
            onChange: ({
              target: {
                value
              }
            }) => onUpdateFilters({
              textKey: SEARCH_KEY,
              value
            })
          })
        }), renderedInlineActions && /*#__PURE__*/_jsx("span", {
          className: "m-left-2",
          children: renderedInlineActions
        })]
      })]
    }), showDivider && /*#__PURE__*/_jsx(HR, {
      distance: "extra-small"
    })]
  });
};

ReviewsHeader.propTypes = {
  onUpdateFilters: PropTypes.func.isRequired,
  renderedButtonRow: PropTypes.node,
  renderedInlineActions: PropTypes.node,
  reviewsCount: PropTypes.number,
  reviewFilters: PropTypes.oneOfType([PropTypes.instanceOf(LegacyReviewFilters), PropTypes.instanceOf(ReviewFilters)]).isRequired,
  showDivider: PropTypes.bool
};
export default ReviewsHeader;